export * from './ProjectBlock';

import { ProjectBlock } from './ProjectBlock';

export default ProjectBlock;
